import { routes as studioRoutes } from './studio/studio.routes';
import { routes as restaurantRoutes } from './restaurant/restaurant.routes';
import settings from './settings/settings.routes';
import conversation from './conversation/conversation.routes';
import { routes as searchRoutes } from '../../modules/search/search.routes';
import { routes as callRoutes } from './calls/routes';
import { routes as contactRoutes } from './contacts/routes';
import { routes as companyRoutes } from './companies/routes';
import { routes as notificationRoutes } from './notifications/routes';
import { routes as incidentRoutes } from './incidents/routes';
import { routes as inboxRoutes } from './inbox/routes';
import { frontendURL } from '../../helper/URLHelper';
import helpcenterRoutes from './helpcenter/helpcenter.routes';
import campaignsRoutes from './campaigns/campaigns.routes';
import {
  publicRoutes as qualificaAIPublicRoutes,
  routes as qualificaAIRoutes,
} from './qualificaAI/qualificaAI.routes';
import { routes as openAIRoutes } from './openai/openai.routes';
import { routes as aiSupervisionRoutes } from './aiSupervision/aiSupervision.routes';
import { routes as proposalRoutes } from './proposals/proposals.routes';
import { routes as creditDashboardRoutes } from './creditDashboard/creditDashboard.routes';
import { routes as portfolioManagementRoutes } from './portfolioManagement/portfolioManagement.routes';
import { routes as creditEngineRoutes } from './creditEngines/creditEngines.routes';
import { routes as manualSimulatorRoutes } from './manualSimulators/manualSimulators.routes';
import { routes as factaOfflineBatchRoutes } from './factaOfflineBatches/factaOfflineBatches.routes';
import { routes as bankQueryRoutes } from './bankQueries/bankQueries.routes';
import { routes as benefit360Routes } from './benefit360/benefit360.routes';
import { routes as funnelRoutes } from './funnels/funnels.routes';
import { routes as whatsappFlowRoutes } from './whatsappFlows/whatsappFlows.routes';
import { routes as whatsappCatalogRoutes } from './whatsappCatalogs/whatsappCatalogs.routes';
import { routes as calendarRoutes } from './calendar/calendar.routes';
import { routes as inventoryRoutes } from './inventory/inventory.routes';
import { routes as shopRoutes } from './shop/shop.routes';
import { routes as referralRoutes } from './referrals/referral.routes';
import { routes as lemitRoutes } from './lemit/lemit.routes';
import { routes as platformAnnouncementRoutes } from './platformAnnouncements/platformAnnouncements.routes';
import { routes as gamificationRoutes } from './gamification/gamification.routes';
import { routes as forumRoutes } from './forum/forum.routes';
import { routes as smsRoutes } from './sms/sms.routes';
import { routes as contractRoutes } from './contracts/contracts.routes';
import { routes as deliveryRoutesRoutes } from './deliveryRoutes/deliveryRoutes.routes';
import { routes as captainRoutes } from './captain/captain.routes';
import AppContainer from './Dashboard.vue';
import Suspended from './suspended/Index.vue';
import NoAccounts from './noAccounts/Index.vue';
import OnboardingAccountDetails from './onboarding/Index.vue';
import OnboardingInboxSetup from './onboarding/InboxSetup.vue';
import TalkviaTour from './tour/Index.vue';

export default {
  routes: [
    ...qualificaAIPublicRoutes,
    {
      path: frontendURL('accounts/:accountId'),
      component: AppContainer,
      children: [
        ...captainRoutes,
        ...inboxRoutes,
        ...conversation.routes,
        ...settings.routes,
        ...callRoutes,
        ...contactRoutes,
        ...companyRoutes,
        ...searchRoutes,
        ...notificationRoutes,
        ...incidentRoutes,
        ...helpcenterRoutes.routes,
        ...campaignsRoutes.routes,
        ...qualificaAIRoutes,
        ...openAIRoutes,
        ...aiSupervisionRoutes,
        ...creditDashboardRoutes,
        ...portfolioManagementRoutes,
        ...creditEngineRoutes,
        ...manualSimulatorRoutes,
        ...factaOfflineBatchRoutes,
        ...bankQueryRoutes,
        ...benefit360Routes,
        ...funnelRoutes,
        ...whatsappFlowRoutes,
        ...whatsappCatalogRoutes,
        ...proposalRoutes,
        ...calendarRoutes,
        ...inventoryRoutes,
        ...restaurantRoutes,
        ...studioRoutes,
        ...contractRoutes,
        ...deliveryRoutesRoutes,
        ...shopRoutes,
        ...referralRoutes,
        ...lemitRoutes,
        ...platformAnnouncementRoutes,
        ...forumRoutes,
        ...gamificationRoutes,
        ...smsRoutes,
        {
          path: 'tour',
          name: 'talkvia_tour',
          meta: {
            permissions: ['administrator', 'agent', 'custom_role'],
          },
          component: TalkviaTour,
        },
      ],
    },
    {
      path: frontendURL('accounts/:accountId/onboarding'),
      name: 'onboarding_account_details',
      meta: {
        permissions: ['administrator', 'agent', 'custom_role'],
      },
      component: OnboardingAccountDetails,
    },
    {
      path: frontendURL('accounts/:accountId/onboarding/inbox-setup'),
      name: 'onboarding_inbox_setup',
      meta: {
        permissions: ['administrator', 'agent', 'custom_role'],
      },
      component: OnboardingInboxSetup,
    },
    {
      path: frontendURL('accounts/:accountId/suspended'),
      name: 'account_suspended',
      meta: {
        permissions: ['administrator', 'agent', 'custom_role'],
      },
      component: Suspended,
    },
    {
      path: frontendURL('no-accounts'),
      name: 'no_accounts',
      component: NoAccounts,
    },
  ],
};
